import { useQuery } from '@tanstack/react-query';
import { httpClient } from '../../services/http.client';
import { queryKeys } from '../../lib/query-keys';

export function useEstimates(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.estimates.all(orgId ?? ''),
    queryFn: () => httpClient.get(`/api/v1/estimates?organization_id=${orgId}`),
    enabled: !!orgId,
    staleTime: 30_000,
    select: (res: any) => {
      const raw = res?.data ?? res;
      return Array.isArray(raw) ? raw : (raw?.data ?? []);
    },
  });
}

export function useEstimateItems(estimateId: string | null, orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.estimates.items(estimateId ?? ''),
    queryFn: () => httpClient.get(`/api/v1/estimates/${estimateId}/items?organization_id=${orgId}`),
    enabled: !!estimateId && !!orgId,
    staleTime: 30_000,
    select: (res: any) => {
      const raw = res?.data ?? res;
      return Array.isArray(raw) ? raw : (raw?.data ?? []);
    },
  });
}
